const LearnIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_ii_930_775)">
                <rect width="32" height="32" rx="6" fill="url(#paint0_linear_930_775)" />
                <path fillRule="evenodd" clipRule="evenodd" d="M17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967L24.5303 15.4697C24.8232 15.7626 24.8232 16.2374 24.5303 16.5303L18.5303 22.5303C18.2374 22.8232 17.7626 22.8232 17.4697 22.5303C17.1768 22.2374 17.1768 21.7626 17.4697 21.4697L22.1893 16.75H8C7.58579 16.75 7.25 16.4142 7.25 16C7.25 15.5858 7.58579 15.25 8 15.25H22.1893L17.4697 10.5303C17.1768 10.2374 17.1768 9.76256 17.4697 9.46967Z" fill="white" />
            </g>
            <defs>
                <filter id="filter0_ii_930_775" x="0" y="-4" width="32" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_930_775" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="-4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_930_775" result="effect2_innerShadow_930_775" />
                </filter>
                <linearGradient id="paint0_linear_930_775" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1C225A" />
                    <stop offset="1" stopColor="#3B49C0" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export default LearnIcon